import { delay } from "../../utils"
import { rest } from "msw"

export const maintenanceMode = [
  rest.get("*/v1/stores/:storeId/maintenance_mode/", function (_req, res, ctx) {
    return res(delay(ctx), ctx.json(require("./fixture.json")))
  }),
]
